<template>
  <div class="landingPage" id="landingPage" ref="landingPage">
    <div v-if="sessionSuccess">
      <div class="alert alert-success text-center mb-0">
        {{ sessionSuccess }}
      </div>
    </div>
    <div v-if="sessionError">
      <div class="alert alert-danger text-center mb-0">
        {{ sessionError }}
      </div>
    </div>
    <div :class="['section-wrapper loading', section.componentName]" v-for="section in mappedSections" :ref="section.sectionId">
    <component
      :is="section.componentName"
      :background-url="section.backgroundUrl"
      :category-id="section.categoryId"
      :classes="section.classes"
      :description="section.description"
      :header-text="section.headerTitle"
      :image-url="section.imageUrl"
      :item-list="section.itemList"
      :key="section.categoryId"
      :link-style="section.linkStyle"
      :link-url="section.linkUrl"
      :link-text="section.linkText"
      :list-type="section.listType"
      :slider-type="section.sliderType"
      :title="section.title"
      :section-ref="section.sectionId"
      :youtube-key="section.youtubeKey"
      :desktop-image-url="section.desktopImageUrl"
      :desktop-image-title="section.desktopImageTitle"
      :mobile-image-url="section.mobileImageUrl"
      :mobile-image-title="section.mobileImageTitle"
      :tablet-image-url="section.tabletImageUrl"
      :tablet-image-title="section.tabletImageTitle"
      :background-type="section.backgroundType"
      :json-rte="section.jsonRTE"
      @initComplete="initComplete"
    ></component>
      <ThePageMetadata v-if="metadata != null" :metadata="metadata"/>
    </div>
  </div>
</template>

<script>
import ThePageMetadata from "./ThePageMetadata.vue";
import { fetchContentStackItems } from "../helpers/sections/helpers.js";

export default {
  name: "TheHomePage",
  components: {
    ThePageMetadata,
    'BlogSection': () => import(/* webpackChunkName: "LandingBlogSection" */ "./landing/BlogSection.vue"),
    'FeaturedSection': () => import(/* webpackChunkName: "LandingFeaturedSection" */ "./landing/FeaturedSection.vue"),
    'FeaturedContentSection': () => import(/* webpackChunkName: "LandingFeaturedContentSection" */ "./landing/FeaturedContentSection.vue"),
    'HeroSection': () => import(/* webpackChunkName: "LandingTheHero" */ "./landing/TheHero.vue"),
    'LatestEditionsSection': () => import(/* webpackChunkName: "LandingLatestEditions" */ "./landing/LatestEditions.vue"),
    'MultiSliderSection': () => import(/* webpackChunkName: "LandingMultiSliderSection" */ "./landing/MultiSliderSection.vue"),
    'SimpleSection': () => import(/* webpackChunkName: "LandingSimpleSection" */ "./landing/SimpleSection.vue"),
    'SimpleYouTubeSection': () => import(/* webpackChunkName: "LandingSimpleYouTubeSection" */  "./landing/SimpleYouTubeSection.vue"),
    'TextOnlySection': () => import(/* webpackChunkName: "LandingTextOnlySection" */  "./landing/TextOnlySection.vue"),
    'FullTextSection': () => import(/* webpackChunkName: "LandingFullTextSection" */  "./landing/FullTextSection.vue"),
    'ImageContentSection': () => import(/* webpackChunkName: "LandingImageContentSection" */  "./landing/ImageContentSection.vue"),
  },
  props: {
    sessionSuccess: {
      type: String,
      default: '',
    },
    sessionError: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      default: '/',
    },
    contentstackEnvironment : {
      type: String,
      default: '',
    },
    contentstackApiKey : {
      type: String,
      default: '',
    },
    contentstackDeliveryToken : {
      type: String,
      default: '',
    },
    content : {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mappedSections: [],
      metadata: undefined,
    };
  },
  methods: {
    initComplete(key) {

      if(typeof key == 'string') {
        //remove forced aspect-ratio for specific section
        this.$refs[key][0].classList.remove('loading');
      }
      //remove initial page-loading placeholder
      document.getElementById('landing-wrapper').classList.remove('loading');

    },
    async getContentstackList() {
      const { sections, metadata } = await fetchContentStackItems({
        path: this.path,
        apiKey: this.contentstackApiKey,
        token: this.contentstackDeliveryToken,
        environment: this.contentstackEnvironment,
        contentType: 'landing_page_content',
        content:this.content,
      })

      this.mappedSections = sections;
      this.metadata = metadata;
    },
  },
  mounted() {
    this.getContentstackList();
  },
};
</script>

<style scoped lang="scss">
#landingPage {
  margin: 3rem auto 0 auto;
  max-width: 120rem;
  width: 100%;
}

@media only screen and (min-width: 767px) {
  #landingPage {
    margin-top: 7rem;
  }
}
</style>
